window.quickShopHtmls = {};
class CardQuickShop extends HTMLElement {
  constructor() {
    super();
    this.productSectionId = 'main-product--quick-shop';
    this.isRendered = false;
    this.observer = null;
    this.abortController = new AbortController();
  }

  async connectedCallback() {
    await new Promise((resolve) => setTimeout(resolve, 0));

    this.productHandle = this.getAttribute('data-product-handle');
    this.productCard = this.closest('product-card');
    this.observeProductCard();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.abortController.abort();
  }

  initProductCardListeners() {
    this.productCard.addEventListener('mouseenter', this.handleMouseEnter.bind(this), {
      signal: this.abortController.signal,
    });
    this.productCard.addEventListener('mouseleave', this.handleMouseLeave.bind(this), {
      signal: this.abortController.signal,
    });
    this.productCard.addEventListener('click', this.handleProductCardClick.bind(this), {
      signal: this.abortController.signal,
    });
  }

  handleMouseEnter() {
    if (this.isRendered) return;

    const height = this.productCard.offsetHeight;
    this.productCard.style.minHeight = `${height}px`;
    this.productCard.classList.add('product-card--hovered');
    this.renderProductQuickShop(this.productHandle);
    this.enableFixScrollCarousel(true);
  }

  handleMouseLeave() {
    this.productCard.style.minHeight = '';
    this.productCard.classList.remove('product-card--hovered');
    this.innerHTML = '';
    this.isRendered = false;
    this.enableFixScrollCarousel(false);
  }

  enableFixScrollCarousel(apply) {
    const scrollCarousel = this.productCard.closest('scroll-carousel');
    const productList = this.productCard.closest('product-list');
    if (scrollCarousel && productList) {
      scrollCarousel.style.position = apply ? 'relative' : '';
      scrollCarousel.style.left = apply ? `-${scrollCarousel.scrollLeft}px` : '';
      scrollCarousel.style.overflow = apply ? 'visible' : '';
      productList.style.overflowX = apply ? 'clip' : '';
    }
  }

  async handleProductCardClick(e) {
    if (!e.target.closest('.quick-shop-variations-carousel')) return;
    const el = e.target.closest('a.thumbnail-swatch');
    if (!el) return;

    e.preventDefault();
    this.querySelector('.thumbnail-swatch.is-selected')?.classList.remove('is-selected');
    el.classList.add('processing-spinner', 'is-selected');
    await this.renderProductQuickShop(el.dataset.handle);
    el.classList.remove('processing-spinner');
    this.loadProductVariations();
  }

  loadProductVariations() {
    const variationsHandle = Array.from(this.querySelectorAll('.product_variations .thumbnail-swatch')).map(
      (el) => el.dataset.handle
    );
    variationsHandle.forEach((handle) => this.fetchProductQuickShop(handle));
  }

  observeProductCard() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.25,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.fetchProductQuickShop(this.productHandle);
          this.initProductCardListeners();
          this.observer.disconnect();
        }
      });
    };

    this.observer = new IntersectionObserver(observerCallback, observerOptions);
    this.observer.observe(this.productCard);
  }

  async fetchProductQuickShop(productHandle, returnHtmlParser = false) {
    if (window.quickShopHtmls[productHandle]) {
      return returnHtmlParser
        ? new DOMParser()
            .parseFromString(window.quickShopHtmls[productHandle], 'text/html')
            .querySelector('.product-card-quick-shop-section')
        : null;
    }

    const url = new URL(`${Shopify.routes.root}products/${productHandle}`, window.location.origin);
    url.searchParams.append('section_id', this.productSectionId);

    const response = await fetch(url);
    const responseHtml = await response.text();
    const newContent = new DOMParser().parseFromString(responseHtml, 'text/html');
    const quickShopElement = newContent.querySelector('.product-card-quick-shop-section');
    window.quickShopHtmls[productHandle] = quickShopElement.outerHTML;

    return returnHtmlParser ? quickShopElement : null;
  }

  async renderProductQuickShop(productHandle) {
    const quickShopHtml = await this.fetchProductQuickShop(productHandle, true);

    if (this.isRendered) {
      const elementsToRerender = ['.product-card__figure', '.product-card-quick-shop-rerender-container'];

      elementsToRerender.forEach((el) => {
        const newElement = quickShopHtml.querySelector(el);
        this.querySelector(el).innerHTML = newElement.innerHTML;
      });
    } else {
      this.innerHTML = quickShopHtml.outerHTML;
      this.isRendered = true;
      this.productCard.classList.add('product-card--quick-shop-rendered');
    }

    this.loadProductVariations();
  }
}

customElements.define('product-card-quick-shop', CardQuickShop);
